var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoriError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 359,
    height: 318,
    viewBox: "0 0 359 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_17090_84513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.258 55.8247L318 42.5664L304.742 55.8247C302.119 58.447 300.334 61.7879 299.61 65.4251C298.887 69.0622 299.258 72.8322 300.677 76.2583C302.096 79.6844 304.5 82.6127 307.583 84.673C310.667 86.7333 314.292 87.8329 318 87.8329C321.708 87.8329 325.334 86.7333 328.417 84.673C331.5 82.6127 333.904 79.6844 335.323 76.2583C336.742 72.8322 337.113 69.0622 336.39 65.4251C335.666 61.7879 333.881 58.447 331.258 55.8247Z",
    fill: "url(#paint0_linear_17090_84513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.701 147C309.701 166.265 305.906 185.341 298.534 203.139C291.162 220.938 280.356 237.11 266.733 250.732C253.111 264.355 236.939 275.161 219.14 282.533C201.342 289.905 182.266 293.7 163.001 293.7C143.736 293.7 124.66 289.905 106.861 282.533C89.0627 275.161 72.8906 264.355 59.2682 250.732C45.6459 237.11 34.84 220.938 27.4676 203.139C20.0953 185.341 16.3008 166.265 16.3008 147L163.001 147H309.701Z",
    fill: "url(#paint1_linear_17090_84513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.225 197.317C156.687 195.73 154.155 195.69 152.568 197.227C150.982 198.764 150.941 201.296 152.479 202.883L158.225 197.317ZM187.92 201.088C189.459 199.504 189.424 196.972 187.84 195.432C186.256 193.892 183.724 193.928 182.184 195.511L187.92 201.088ZM152.479 202.883C155.319 205.815 160.418 209.147 166.79 209.837C173.394 210.551 180.843 208.367 187.92 201.088L182.184 195.511C176.66 201.193 171.584 202.309 167.651 201.883C163.486 201.432 160.034 199.184 158.225 197.317L152.479 202.883Z",
    fill: "#41435B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.025 144.06C252.563 145.647 255.095 145.687 256.682 144.15C258.268 142.613 258.309 140.081 256.771 138.494L251.025 144.06ZM221.33 140.289C219.791 141.873 219.826 144.405 221.41 145.945C222.994 147.485 225.526 147.449 227.066 145.865L221.33 140.289ZM256.771 138.494C253.931 135.562 248.832 132.23 242.46 131.54C235.856 130.826 228.407 133.01 221.33 140.289L227.066 145.865C232.59 140.184 237.666 139.068 241.599 139.494C245.764 139.945 249.216 142.193 251.025 144.06L256.771 138.494Z",
    fill: "#41435B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.378 101.872C240.11 100.801 239.023 100.15 237.952 100.419C236.88 100.688 236.23 101.775 236.499 102.846L240.378 101.872ZM269.916 119.727C270.979 119.427 271.597 118.321 271.296 117.258C270.995 116.196 269.889 115.578 268.827 115.879L269.916 119.727ZM236.499 102.846C237.534 106.971 240.436 112.703 245.855 116.665C251.368 120.696 259.276 122.74 269.916 119.727L268.827 115.879C259.258 118.588 252.645 116.675 248.216 113.437C243.693 110.13 241.233 105.279 240.378 101.872L236.499 102.846Z",
    fill: "#41435B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5471 117.692C53.4849 117.389 52.3783 118.005 52.0755 119.067C51.7727 120.129 52.3884 121.236 53.4507 121.538L54.5471 117.692ZM84.7791 101.039C85.0499 99.968 84.4014 98.8803 83.3305 98.6095C82.2597 98.3387 81.172 98.9872 80.9012 100.058L84.7791 101.039ZM53.4507 121.538C57.5411 122.704 63.9559 123.057 70.0968 120.345C76.3441 117.587 82.0676 111.76 84.7791 101.039L80.9012 100.058C78.4629 109.699 73.4998 114.47 68.4809 116.686C63.3557 118.949 57.9247 118.654 54.5471 117.692L53.4507 121.538Z",
    fill: "#41435B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9317 144.06C91.4688 145.647 94.0012 145.687 95.5879 144.15C97.1746 142.613 97.2148 140.081 95.6776 138.494L89.9317 144.06ZM60.2367 140.289C58.6968 141.873 58.7324 144.405 60.3164 145.945C61.9003 147.485 64.4327 147.449 65.9727 145.865L60.2367 140.289ZM95.6776 138.494C92.8369 135.562 87.7387 132.23 81.3662 131.54C74.7624 130.826 67.3135 133.01 60.2367 140.289L65.9727 145.865C71.4959 140.184 76.572 139.068 80.5057 139.494C84.6707 139.945 88.1225 142.193 89.9317 144.06L95.6776 138.494Z",
    fill: "#41435B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_17090_84513",
    x: 0.300781,
    y: 34,
    width: 358.699,
    height: 283.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17090_84513"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_17090_84513",
    result: "effect2_dropShadow_17090_84513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_17090_84513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17090_84513",
    x1: 299.25,
    y1: 65.1997,
    x2: 336.75,
    y2: 65.1997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1573DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17090_84513",
    x1: 16.3008,
    y1: 147,
    x2: 309.701,
    y2: 147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B53E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895154,
    stopColor: "#4FD5D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoriError);
export default __webpack_public_path__ + "static/media/sori_error.c4167951db93c524a1bfa31d7591cab1.svg";
export { ForwardRef as ReactComponent };